<div *ngIf="showDiv === 'checkout BX'">
  <div *ngIf="message">{{ message }}</div>
  <div *ngIf="extraMessage" [innerHTML]="extraMessage"></div>
</div>
